export class Address {
  constructor(
      public street: string,
      public houseno: string,
      public zipcode: string,
      public city: string,
      public country: string,
      public webId: number,
      public backendId: number,
      public userBackendId: number,
      public userSSOId: number,
      public district: string,
      public longitude?: number,
      public latitude?: number,
      public countryDescription?: string,
      // Bestandteile des Hausnummern-Vektors, wie ihn HouseNo zerlegt. Sie stehen nur an Adressen, die
      // vorher durch eine solche Zerlegung gelaufen sind (Oesterreich-Darstellung Stiege/Stock/Tuer).
      public stock?: string,
      public stiege?: string,
      public tuer?: string
  ) {}
}
